import type { IPlatformAdapter } from './interfaces/IPlatformAdapter';

/**
 * Browser implementation of the platform adapter.
 * Uses native DOM APIs (window, document, MutationObserver).
 *
 * @public
 */
export class BrowserPlatformAdapter implements IPlatformAdapter {

    // #region Methods

    public matchMedia(query: string): boolean {
        return window.matchMedia(query).matches;
    }

    public setDocumentAttribute(name: string, value: string): void {
        document.documentElement.setAttribute(name, value);
    }

    public getDocumentAttribute(name: string): string | null {
        return document.documentElement.getAttribute(name);
    }

    public observeDocumentAttributes(
        attributes: Array<string>,
        callback: (attributeName: string, newValue: string | null) => void
    ): () => void {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName) {
                    const newValue = document.documentElement.getAttribute(mutation.attributeName);
                    callback(mutation.attributeName, newValue);
                }
            });
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: attributes
        });

        // Return unsubscribe function
        return () => observer.disconnect();
    }

    // #endregion

}
